const getPriceWithDecimalFromTotalAmountStripe = (totalAmount: string) => {
	return Number(totalAmount) / 100;
};

export default getPriceWithDecimalFromTotalAmountStripe;
